import { Table } from "@mui/material";
import React from "react";
import Body from "./Body";
import Header from "./Header";
import Pagination from "./Pagination";
import styles from "./styles";

export interface HeaderDonnees {
  id: string;
  idTriable?: string;
  libelle: string;
  isTriable: boolean;
}

interface Props {
  onConsulter(id: string | number): void;
  donneesTableau: any;
  alerteEnCoursSuppression: boolean;
  headerDonnees: HeaderDonnees[];
  type: "adb" | "utilisateurs" | "dossiersLocation" | "messages";
  trierPar: string;
  ordreDeTrie: "asc" | "desc";
  onTrier: (event: React.MouseEvent, idColonne: string) => void;
  isPaginer: boolean;
  page: number;
  nbrElementTotal: number;
  nbrElementParPage: number;
  nombreElementParPageOptions?: number[];
  onChangerPage: (event: React.MouseEvent | null, page: number) => void;
  onChangerNbrResultatParPage: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    nbrElement: number
  ) => void;
  onChangeStatut?(id: string | number, statut: boolean): void;
  isChargeClienteleBesse?: boolean;
  isAccepterRefuserLocationLoading?: boolean;
  onSetDuplicationDossier?(ref: string): void;
  onSetAccepterDossier?(ref: string): void;
  onSetRefuserDossier?(ref: string): void;
  onSetAccepterRefuserDossier?(dossierLocationItem: any): void;
  canAcceptRefuseLocation?: boolean;
  infoProfil?: any;
  onDelete(id: string | number): void;
  onGenerer(id: string | number): void;
  genererLoading?: boolean;
}

const Tableau: React.FC<Props> = ({
  isPaginer,
  onConsulter,
  onTrier,
  donneesTableau,
  alerteEnCoursSuppression,
  trierPar,
  ordreDeTrie,
  nbrElementTotal,
  nbrElementParPage,
  page,
  onChangerPage,
  onChangerNbrResultatParPage,
  nombreElementParPageOptions,
  headerDonnees,
  type,
  onChangeStatut,
  isChargeClienteleBesse,
  onSetDuplicationDossier,
  onSetAccepterDossier,
  onSetRefuserDossier,
  onSetAccepterRefuserDossier,
  isAccepterRefuserLocationLoading,
  canAcceptRefuseLocation,
  infoProfil,
  onDelete,
  onGenerer,
  genererLoading,
}) => {
  return (
    <Table className="tableau" sx={styles}>
      <Header
        headerDonnees={headerDonnees}
        trierPar={trierPar}
        ordreDeTrie={ordreDeTrie}
        onTrier={onTrier}
      />
      <Body
        donneesTableau={donneesTableau}
        alerteEnCoursSuppression={alerteEnCoursSuppression}
        onConsulter={onConsulter}
        onGenerer={onGenerer}
        onDelete={onDelete}
        type={type}
        onChangeStatut={onChangeStatut}
        isChargeClienteleBesse={isChargeClienteleBesse}
        onSetDuplicationDossier={onSetDuplicationDossier}
        onSetAccepterDossier={onSetAccepterDossier}
        onSetRefuserDossier={onSetRefuserDossier}
        onSetAccepterRefuserDossier={onSetAccepterRefuserDossier}
        isAccepterRefuserLocationLoading={isAccepterRefuserLocationLoading}
        genererLoading={genererLoading}
        canAcceptRefuseLocation={canAcceptRefuseLocation}
        infoProfil={infoProfil}
      />
      {isPaginer && (
        <Pagination
          page={page}
          colSpan={headerDonnees.length - 1}
          nbrElementTotal={nbrElementTotal}
          nbrElementParPage={nbrElementParPage}
          nbrElementParPageOptions={nombreElementParPageOptions}
          onChangerPage={onChangerPage}
          onChangerNbrResultatParPage={onChangerNbrResultatParPage}
        />
      )}
    </Table>
  );
};

export default Tableau;
